import { createBrowserRouter, Navigate, RouteObject } from "react-router";

import { enabledFeatures } from "../../features";
import { RouteConstants } from "../../models/enums/route-constants.enum";
import { AuthenticateApp } from "../Core/AuthenticateApp";
import {
  AdminPage,
  FeaturePage,
  GlobalErrorsPage,
  LandingPage,
  NoAIFeaturePermissionsPage,
  PageLogout,
  TermsOfUseRejectedPage,
} from "../Pages";
import { AdminAreaGuard, AIFeaturePermissionsGuard, BudgetGuard, TermsOfUseGuard } from "./Guards";

export const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <AuthenticateApp />,
      children: [
        {
          path: `/${RouteConstants.Logout}`,
          element: <PageLogout />,
        },
        {
          element: <Navigate to={`/${RouteConstants.LandingPage}`} />,
          index: true,
        },
        {
          path: `/${RouteConstants.NoAIFeaturePermissions}`,
          element: <NoAIFeaturePermissionsPage />,
        },
        {
          path: `/${RouteConstants.RejectedTermsOfUse}`,
          element: <TermsOfUseRejectedPage />,
        },
        {
          path: `/${RouteConstants.LandingPage}`,
          element: (
            <AIFeaturePermissionsGuard>
              <TermsOfUseGuard>
                <LandingPage />
              </TermsOfUseGuard>
            </AIFeaturePermissionsGuard>
          ),
        },
        {
          path: `/${RouteConstants.NoBudget}`,
          element: <GlobalErrorsPage />,
        },
        {
          path: `/${RouteConstants.AdminArea}`,
          element: (
            <AdminAreaGuard>
              <TermsOfUseGuard>
                <AdminPage />
              </TermsOfUseGuard>
            </AdminAreaGuard>
          ),
        },
        {
          path: `/${RouteConstants.Ai}`,
          element: (
            <AIFeaturePermissionsGuard>
              <TermsOfUseGuard>
                <BudgetGuard>
                  <FeaturePage />
                </BudgetGuard>
              </TermsOfUseGuard>
            </AIFeaturePermissionsGuard>
          ),
          children: enabledFeatures()
            .map(f => f.route)
            .filter((route): route is RouteObject => !!route),
        },
        {
          path: "*",
          element: <Navigate to={`/${RouteConstants.LandingPage}`} />,
          index: true,
        },
      ],
    },
  ],
  {
    future: {},
  },
);
